import { Clock3, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PreparingPage() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 flex items-center justify-center p-6">
      <section className="w-full max-w-xl rounded-3xl bg-white shadow-2xl shadow-slate-200/60 border border-slate-200 p-10 text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-amber-100 text-amber-600">
          <Clock3 size={38} />
        </div>

        <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-amber-50 px-4 py-1 text-xs font-bold tracking-widest text-amber-700">
          <Sparkles size={14} />
          LAPOIT
        </div>

        <h1 className="mt-5 text-4xl font-black tracking-tight text-slate-900">
          준비중입니다
        </h1>

        <p className="mt-4 text-slate-500 leading-7">
          더 좋은 서비스를 제공하기 위해
          <br />
          현재 해당 기능을 준비하고 있습니다.
        </p>

        <button
          onClick={() => navigate(-1)}
          className="mt-10 h-12 w-full rounded-2xl bg-slate-900 text-white font-semibold transition hover:bg-slate-800 active:scale-[0.98]"
        >
          이전 페이지로
        </button>
      </section>
    </main>
  );
}